var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from 'common/UIToolKit/Icon.vue';
import { NotificationsAggregate } from 'packages/notifications/NotificationsAggregator';
import { DateUtility } from 'packages/utilities/DateUtility';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';
import DateField from 'ui/v1/DateField.vue';
import { MovedNotificationData } from 'packages/notifications/MovedNotificationData';
import { NotificationsRepository } from 'packages/notifications/NotificationsRepository';
import env from 'config/env.js';
import { BulkMoveNotificationData } from 'packages/notifications/BulkMoveNotificationData';
import { LanguageService } from 'services/LanguageService';
import { container } from 'tsyringe';
var iconMap = {
    talent_comment: 'message-bubble',
    new_talent: 'talent-join-pipeline',
    talent_moved: 'talent-moved',
    inbound_email: 'talent-email',
    talents_moved: 'bulk-move-pipeline',
};
var NotificationDrawerAggregate = /** @class */ (function (_super) {
    __extends(NotificationDrawerAggregate, _super);
    function NotificationDrawerAggregate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.jobName = '...';
        _this.showAllNotifications = false;
        _this.notificationsRepo = container.resolve(NotificationsRepository);
        _this.languageService = container.resolve(LanguageService);
        return _this;
    }
    Object.defineProperty(NotificationDrawerAggregate.prototype, "textData", {
        get: function () {
            var _a, _b;
            return {
                name1: this.names[0],
                name2: this.names[1],
                count: this.count,
                pipeline: this.aggregate.jobName,
                fromStage: (_a = this.aggregate.fromStage) === null || _a === void 0 ? void 0 : _a.name,
                toStage: (_b = this.aggregate.toStage) === null || _b === void 0 ? void 0 : _b.name,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "talents", {
        get: function () {
            return this.isBulkNotification ? this.bulkData.talents : this.aggregate.notifications.map(function (n) { return n.data.talent; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "isBulkNotification", {
        get: function () {
            return this.aggregate.notifications[0].data instanceof BulkMoveNotificationData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "bulkData", {
        get: function () {
            return this.isBulkNotification ? this.aggregate.notifications[0].data : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "icon", {
        get: function () {
            return iconMap[this.aggregate.event];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "time", {
        get: function () {
            return new DateUtility(this.aggregate.notifications[0].createdAt).timeSinceFormat(this.languageService.currentLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "translationKey", {
        get: function () {
            var event = this.aggregate.event === 'talents_moved' ? 'talent_moved' : this.aggregate.event;
            return (this.talents.length <= 2)
                ? event + "_" + this.talents.length
                : event + "_many";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "count", {
        get: function () {
            return (this.talents.length > 2)
                ? this.talents.length - 2
                : this.talents.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "total", {
        get: function () {
            return this.aggregate.notifications.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationDrawerAggregate.prototype, "names", {
        get: function () {
            return this.talents.map(function (talent) { return (talent ? talent.name : ''); });
        },
        enumerable: false,
        configurable: true
    });
    NotificationDrawerAggregate.prototype.getSingleTranslationData = function (notification) {
        if (!(notification.data instanceof MovedNotificationData)) {
            return {
                name: notification.data.talent ? notification.data.talent.name : '',
                from: null,
                to: null,
            };
        }
        return {
            name: notification.data.talent ? notification.data.talent.name : '',
            from: notification.data.from,
            to: notification.data.to,
        };
    };
    NotificationDrawerAggregate.prototype.markReadAndNavigateToJob = function (aggregate) {
        var _this = this;
        var promises = aggregate.notifications.map(function (notification) { return _this.notificationsRepo.markNotificationRead(notification.id); });
        Promise.all(promises).then(function () {
            window.location.href = env.APPS.PRODUCT.URL + "jobs/" + aggregate.jobId;
        });
    };
    var _a;
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof NotificationsAggregate !== "undefined" && NotificationsAggregate) === "function" ? _a : Object)
    ], NotificationDrawerAggregate.prototype, "aggregate", void 0);
    NotificationDrawerAggregate = __decorate([
        Component({
            components: {
                DateField: DateField,
                Icon: Icon,
                UiTextButton: UiTextButton,
            },
        })
    ], NotificationDrawerAggregate);
    return NotificationDrawerAggregate;
}(Vue));
export default NotificationDrawerAggregate;
